import axios from "axios";
import {WORKFLOW_API_HOST} from "@/core/variables";
import {Workflow, WorkflowCreate} from "@/model/Workflow";

class WorkflowRepository {
    async read(workflowId: string) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflows/${workflowId}`);
    };

    async create(body: WorkflowCreate) {
        return axios.post(`${WORKFLOW_API_HOST}/v2/workflows`, body);
    }

    async paginate(props: {page: number, size: number, name?: string, labels?: string[]}) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflows/paginate`, {
            params: {
                page: props.page,
                size: props.size,
                name: props.name,
                labels: props.labels? JSON.stringify(props.labels): undefined
            }
        });
    };

    async find(workflowIds: string[]) {
        return axios.get(`${WORKFLOW_API_HOST}/v2/workflows`, {
            params: {workflowIds: workflowIds.join(',')}
        });
    };

    async update(workflow: Workflow) {
        return axios.put(`${WORKFLOW_API_HOST}/v2/workflows/${workflow._id}`, {
            workflow: workflow
        });
    };

    async run(workflowUserId: string, workflowId: string, params: object, sessionId?: string) {
        return axios.post(`${WORKFLOW_API_HOST}/v2/workflows/${workflowId}/run`, {
            userId: workflowUserId,
            params: params,
            sessionId: sessionId
        });
    };

    async clone(workflowId: string, workflowName: string) {
        return axios.post(`${WORKFLOW_API_HOST}/v2/workflows/${workflowId}/clone`, {
            newWorkflowName: workflowName
        })
    };
}
const workflowRepository = new WorkflowRepository();
export default workflowRepository;
